<template>
    <div>
        <loading :active.sync="is_loading" 
        :can-cancel="false" 
        :is-full-page="true"></loading>
        <Navbar />
        <div class="container-fluid">
            <SidebarSarpras/>
            <main class="main" id="main">
                <Breadcrumb :links="[{url: '/dashboard', text:'Home'}, {url: '#', text: 'Riwayat Inspeksi Sarana dan Prasana'}]"/>
                <h2><b>Riwayat Inspeksi {{ name }} ({{ number }})</b></h2>
                <div class="card">
                    <div class="card-body">
                        <dataset
                            v-slot="{ds}"
                            :ds-data="inspections"
                            :ds-sortby="sortBy"
                            :ds-search-in="['nama_objek', 'nomor_aset']">
                                <div class="float-end mb-3">
                                    <router-link :to="{name: 'InspectionAdd', params: { id: $route.params.id }}" class="btn btn-primary"><i class="fa fa-plus"></i> Tambah Riwayat Inspeksi</router-link>
                                </div>
                                <div class="clearfix"></div>
                                <div class="row mb-3" :data-page-count="ds.dsPagecount">
                                    <div class="col-md-6 mb-md-0">
                                        <dataset-show />
                                    </div>
                                    <div class="col-md-6">
                                        <dataset-search ds-search-placeholder="Search..." />
                                    </div>
                                </div>
                                <table class="table table-bordered">
                                    <thead>
                                        <tr>
                                            <th>Kondisi Fungsi<br>(%)</th>
                                            <th>Kondisi Fisik<br>(%)</th>
                                            <th>Penjelasan Kondisi</th>
                                            <th>Riwayat Perbaikan</th>
                                            <th>Layanan di Hilir</th>
                                            <th>Perkiraan Biaya Kerugian</th>
                                            <th>Perikiraan Biaya Perbaikan</th>
                                            <th>Skala Prioritas</th>
                                            <th>Tanggal Inspeksi</th>
                                            <th>Foto</th>
                                            <th></th>
                                        </tr>
                                    </thead>
                                    <dataset-item tag="tbody">
                                        <template #default="{ row }">
                                            <tr>
                                                <td>{{ row.kondisi_fungsi }}</td>
                                                <td>{{ row.kondisi_fisik }}</td>
                                                <td>{{ row.penjelasan_kondisi }}</td>
                                                <td>{{ row.riwayat_perbaikan }}</td>
                                                <td>{{ row.layanan_hilir }}</td>
                                                <td>Rp. {{ Intl.NumberFormat('id-ID').format(Number(row.biaya_kerugian)) }}</td>
                                                <td>Rp. {{ Intl.NumberFormat('id-ID').format(Number(row.biaya_perbaikan)) }}</td>
                                                <td><span :class="`priority priority_${row.skala_prioritas}`">{{ row.skala_prioritas | translatePriority }}</span></td>
                                                <td>{{ row.inspection_date }}</td>
                                                <td>
                                                    <button
                                                        v-for="photo in row.photo"
                                                        :key="photo"
                                                        type="button"
                                                        class="inspection-thumbnail-button"
                                                        @click="openImagePreview(photo)"
                                                    >
                                                        <img :src="photo" width="50" class="border mb-3 inspection-thumbnail" alt="Foto inspeksi">
                                                    </button>
                                                </td>
                                                <td>
                                                    <button to="#" class="btn btn-danger btn-sm me-2"><i class="fa fa-trash"></i></button>
                                                    <router-link
                                                    :to="{name: 'InspectionEdit', params: { id: $route.params.id, inspection_id: row.id}}"
                                                    class="btn btn-success btn-sm">
                                                        <i class="fa fa-pen"></i>
                                                    </router-link>
                                                </td>
                                            </tr>
                                        </template>
                                    </dataset-item>
                                </table>
                                <div class="d-flex flex-md-row flex-column justify-content-between align-items-center">
                                    <dataset-info class="mb-2 mb-md-0" />
                                    <dataset-pager />
                                </div>
                            </dataset>
                    </div>
                </div>
            </main>
        </div>
        <div v-if="preview_image" class="inspection-preview-overlay" @click="closeImagePreview">
            <button type="button" class="inspection-preview-close" @click.stop="closeImagePreview">
                <i class="fa fa-times"></i>
            </button>
            <img :src="preview_image" class="inspection-preview-image" alt="Preview foto inspeksi" @click.stop>
        </div>
    </div>
</template>

<script>
import Navbar from '../../../components/Navbar.vue'
import Breadcrumb from '../../../components/Breadcrumb.vue'
import Loading from 'vue-loading-overlay';
import moment from 'moment';
import 'vue-loading-overlay/dist/vue-loading.css'
import SidebarSarpras from '../../../components/SidebarSarpras.vue'
import axios from 'axios'
import { quillEditor } from 'vue-quill-editor'
import { 
  Dataset,
  DatasetItem,
  DatasetInfo,
  DatasetPager,
  DatasetSearch,
  DatasetShow
} from 'vue-dataset'

// require styles
import 'quill/dist/quill.core.css'
import 'quill/dist/quill.snow.css'
import 'quill/dist/quill.bubble.css'

export default {
    components: {
        Navbar,
        Loading,
        Breadcrumb,
        SidebarSarpras,
        quillEditor,
        Dataset,
        DatasetItem,
        DatasetInfo,
        DatasetPager,
        DatasetSearch,
        DatasetShow
    },
    data(){
        return {
            is_loading: false,
            inspections: [],
            name: '',
            number: '',
            preview_image: null
        }
    },
    methods: {
        getData(){
            axios.get(`${this.$endpoints.sarpras}/inspections`, {
                params: {
                    structure_id: this.$route.params.id
                }
            })
            .then(response => {
                this.inspections = response.data;
            })
        },
        getStructure(){
            axios.get(`${this.$endpoints.sarpras}/structures/${this.$route.params.id}`)
            .then(response => {
                this.name = response.data.nama_objek;
                this.number = response.data.nomor_aset;
            })
        },
        openImagePreview(photo){
            this.preview_image = photo;
        },
        closeImagePreview(){
            this.preview_image = null;
        }
    },
    filters: {
        translatePriority(val){
            switch(val){
                case 1:
                    return "Segera";

                case 2:
                    return "Perlu"

                case 3:
                    return "Dapat ditangguhkan"
            }
        }
    },
    computed: {
        sortBy(){
            return this.inspections.reduce((acc, o) => {
                if (o.sort) {
                o.sort === 'asc' ? acc.push(o.field) : acc.push('-' + o.field)
                }

                return acc
            }, [])
        }
    },
    mounted(){
        this.getData();
        this.getStructure();
    }
}
</script>

<style>
    .priority{
        padding: 1px 5px;
        border-radius: 4px;
    }

    .priority_1{
        background: rgb(240, 70, 70);
        color: #fff;
    }

    .priority_2{
        background: rgb(248, 198, 91);
        color: #fff;
    }

    .priority_3{
        background: rgb(74, 255, 144);
        color: #333;
    }

    .inspection-thumbnail-button{
        border: 0;
        background: transparent;
        padding: 0;
        margin-right: 8px;
        cursor: pointer;
    }

    .inspection-thumbnail{
        object-fit: cover;
        height: 50px;
    }

    .inspection-preview-overlay{
        position: fixed;
        inset: 0;
        background: rgba(0, 0, 0, 0.8);
        display: flex;
        align-items: center;
        justify-content: center;
        padding: 24px;
        z-index: 1050;
    }

    .inspection-preview-image{
        max-width: 90vw;
        max-height: 90vh;
        border-radius: 8px;
        box-shadow: 0 8px 32px rgba(0, 0, 0, 0.35);
    }

    .inspection-preview-close{
        position: absolute;
        top: 20px;
        right: 20px;
        width: 40px;
        height: 40px;
        border: 0;
        border-radius: 50%;
        background: #dc3545;
        color: #fff;
        display: flex;
        align-items: center;
        justify-content: center;
        cursor: pointer;
    }
</style>
